import React from "react";
import {Button, Result} from "antd";

import BaseComponent from "./redare/components/BaseComponent";


export class Page404 extends BaseComponent {
    componentDidMount() {
        this._onBack();
    }


    _onBack() {
        let ctx = window._ctxApi;
        if (window._ctxApi === '') {
            ctx = '/';
        }
        window.location.href = ctx;
    }

    render() {
        return (
            <Result
                status="404"
                title="404"
                subTitle="您访问的页面不存在."
                extra={<Button type="primary" onClick={this._onBack.bind(this)}>返回</Button>}
            />
        )
    }
}

export class Page500 extends BaseComponent {
    _onBack() {
        let ctx = window._ctxApi;
        if (window._ctxApi === '') {
            ctx = '/';
        }
        window.location.href = ctx;
    }
    render() {
        return (
            <Result
                status="500"
                title="500"
                subTitle="您访问的页面出错了，请稍后访问."
                extra={<Button type="primary" onClick={this._onBack.bind(this)}>返回</Button>}
            />
        )
    }
}

